if (!customElements.get('gemstop-catalogue')) {
  customElements.define('gemstop-catalogue', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('submit', event => this.onSubmit(event), options);
      window.addEventListener('popstate', () => this.load(location.href, false), options);
      this.querySelector('[data-gss-dialog]').addEventListener('close', () => this.lastFocus?.focus(), options);
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-gss-term]')) return;
        this.request?.abort();
        this.request = null;
        this.removeAttribute('aria-busy');
        clearTimeout(this.searchDelay);
        this.searchDelay = setTimeout(() => this.querySelector('[data-gss-search]').requestSubmit(), 350);
      }, options);
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-gss-enquiry-quantity]')) return;
        const item = this.enquiry.find(item => item.id === event.target.dataset.gssEnquiryQuantity);
        try { this.saveEnquiry(GemStopSupermarketState.updateEnquiry(this.enquiry, item, Number(event.target.value))); }
        catch (error) { event.target.setCustomValidity(error.message); event.target.reportValidity(); }
      }, options);
      this.enquiry = [];
      try {
        const stored = JSON.parse(localStorage.getItem('gemstop-supermarket-enquiry') || '[]');
        for (const item of stored) {
          if (typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/products/'))
            this.enquiry = GemStopSupermarketState.updateEnquiry(this.enquiry, item, item.quantity);
        }
      } catch (_) { this.enquiry = []; }
      this.renderEnquiry();
      this.restoreTerm();
    }
    disconnectedCallback() {
      clearTimeout(this.searchDelay);
      this.listeners?.abort();
      this.request?.abort();
      this.detailsRequest?.abort();
      this.bound = false;
    }
    restoreTerm() {
      const url = new URL(location.href);
      const term = this.querySelector('[data-gss-term]');
      if (term) term.value = url.searchParams.get('supermarket_query') || '';
      this.querySelectorAll('[data-gss-navigation]').forEach(link => {
        link.setAttribute('aria-current', new URL(link.href).pathname === url.pathname ? 'true' : 'false');
      });
    }
    onSubmit(event) {
      if (event.target.matches('[data-gss-sort]')) {
        event.preventDefault();
        const url = new URL(location.href);
        url.searchParams.set('sort_by', new FormData(event.target).get('sort_by'));
        url.searchParams.delete('page');
        this.load(url.href);
        return;
      }
      if (!event.target.matches('[data-gss-search]')) return;
      clearTimeout(this.searchDelay);
      event.preventDefault();
      const text = this.querySelector('[data-gss-term]').value;
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.searchParams.set('view', 'gemstop-supermarket');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('q', GemStopSupermarketState.buildQuery(text));
      url.searchParams.set('supermarket_query', text);
      this.load(url.href);
    }
    onClick(event) {
      const add = event.target.closest('[data-gss-enquire]');
      if (add) {
        const item = {id:add.dataset.id,title:add.dataset.title,url:add.dataset.url};
        const previous = this.enquiry.find(entry => entry.id === item.id);
        this.saveEnquiry(GemStopSupermarketState.updateEnquiry(this.enquiry, item, Math.min(999,(previous?.quantity || 0) + 1)));
        this.querySelector('[data-gss-status]').textContent = 'Added to your enquiry list';
        return;
      }
      const remove = event.target.closest('[data-gss-remove]');
      if (remove) { this.saveEnquiry(this.enquiry.filter(item => item.id !== remove.dataset.gssRemove)); return; }
      if (event.target.closest('[data-gss-copy]')) {
        const message = this.querySelector('[data-gss-message]');
        message.focus(); message.select();
        this.querySelector('[data-gss-enquiry-status]').textContent = 'Message selected. Copy it and send it using your preferred contact method.';
        return;
      }
      const close = event.target.closest('[data-gss-close]');
      if (close) { this.detailsRequest?.abort(); this.querySelector('[data-gss-dialog]').close(); return; }
      const details = event.target.closest('[data-gss-details], [data-gss-details-url]');
      if (details) {
        event.preventDefault();
        this.openDetails(details.dataset.gssDetailsUrl || details.href, details);
        return;
      }
      const link = event.target.closest('[data-gss-navigation], .gss-pagination a');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.querySelectorAll('[data-gss-collection-picker]').forEach(picker => { picker.open = false; });
      this.load(link.href);
    }
    saveEnquiry(list) {
      this.enquiry = list;
      try { localStorage.setItem('gemstop-supermarket-enquiry', JSON.stringify(list)); }
      catch (_) { this.querySelector('[data-gss-enquiry-status]').textContent = 'This browser cannot save your list. Copy the message before leaving.'; }
      this.renderEnquiry();
    }
    renderEnquiry() {
      const list = this.querySelector('[data-gss-enquiry-list]');
      if (!list) return;
      list.replaceChildren();
      for (const item of this.enquiry) {
        const row = document.createElement('li');
        const name = document.createElement('span'); name.textContent = item.title;
        const quantity = document.createElement('input'); quantity.type = 'number'; quantity.min = '1'; quantity.max = '999'; quantity.step = '1'; quantity.value = item.quantity;
        quantity.dataset.gssEnquiryQuantity = item.id; quantity.setAttribute('aria-label', 'Quantity for ' + item.title);
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.dataset.gssRemove = item.id; remove.setAttribute('aria-label', 'Remove ' + item.title);
        row.append(name, quantity, remove); list.append(row);
      }
      this.querySelector('[data-gss-enquiry-count]').textContent = this.enquiry.length;
      this.querySelector('[data-gss-message]').value = this.enquiry.length ? GemStopSupermarketState.enquiryText(this.enquiry) : '';
    }
    async load(href, push = true) {
      this.request?.abort();
      const request = this.request = new AbortController();
      this.setAttribute('aria-busy', 'true');
      const status = this.querySelector('[data-gss-status]');
      status.textContent = 'Loading products…';
      try {
        const response = await fetch(href, { signal: request.signal });
        if (!response.ok) throw new Error('Unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = document.querySelector('[data-gss-results]');
        if (!results) throw new Error('Unavailable');
        if (request !== this.request) return;
        this.querySelector('[data-gss-results]').replaceWith(results);
        if (push) history.pushState({}, '', href);
        this.restoreTerm();
        status.textContent = 'Products updated';
        this.querySelector('[data-gss-results]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      } catch (error) {
        if (error.name !== 'AbortError' && request === this.request) {
          status.replaceChildren(document.createTextNode('Products could not be loaded. '));
          const fallback = document.createElement('a');
          fallback.href = href;
          fallback.textContent = 'Open this page';
          status.append(fallback);
        }
      } finally {
        if (request === this.request) this.removeAttribute('aria-busy');
      }
    }
    async openDetails(href, trigger) {
      this.detailsRequest?.abort();
      const request = this.detailsRequest = new AbortController();
      this.lastFocus = trigger;
      const dialog = this.querySelector('[data-gss-dialog]');
      const content = dialog.querySelector('[data-gss-dialog-content]');
      content.textContent = 'Loading details…';
      if (!dialog.open) dialog.showModal();
      try {
        const url = new URL(href, location.origin);
        url.searchParams.set('view', 'gemstop-supermarket-details');
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const details = document.querySelector('[data-gss-product-details]');
        if (!details) throw new Error('Unavailable');
        if (request === this.detailsRequest && dialog.open) content.replaceChildren(details);
      } catch (error) {
        if (error.name !== 'AbortError' && request === this.detailsRequest && dialog.open) {
          const link = document.createElement('a');
          link.href = href;
          link.textContent = 'View product details';
          content.replaceChildren(link);
        }
      }
    }
  });
}
